module.exports = __webpack_public_path__ + "img/MTABAPPSPO2.74e98ffe.svg";